import React, { useState, useEffect } from "react";
import { BsPersonPlusFill } from "react-icons/bs";
import { IoMdAdd } from "react-icons/io";
import { Row, Form, Col, Button, Alert } from "react-bootstrap";
import axios from '../../../Authservices/axiosInstance';
import { useNavigate } from "react-router-dom";

// Custom Select Component
const CustomSelect = ({ options, value, onChange, placeholder }) => (
  <Form.Control
    as="select"
    value={value}
    onChange={(e) => onChange(e.target.value)}
  >
    <option value="">{placeholder}</option>
    {options.map((option, index) => (
      <option key={index} value={option.username}>
        {option.username}
      </option>
    ))}
  </Form.Control>
);

export default function AddManualLeave() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [leaveCount, setLeaveCount] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("success");
  const navigate = useNavigate();

  // Fetch users
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          "https://backend.ems.uk.hiradentallab.com/api/user/getAllUsers"
        );
        const usernames = response.data.map((user) => ({
          username: user.username,
          _id: user._id,
          name: user.name,
        }));
        setUsers(usernames);
      } catch (error) {
        console.error("Error fetching users:", error);
        showAlertMessage("Failed to fetch users. Please try again later.", "danger");
      }
    };
    fetchUsers();
  }, []);

  const showAlertMessage = (message, variant = "success") => {
    setAlertMessage(message);
    setAlertVariant(variant);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
      if (variant === "success") {
        navigate("/leave-records");
      }
    }, 2000);
  };

  const handleAddLeave = async () => {
    if (!selectedUser) {
      showAlertMessage("Please select a user.", "warning");
      return;
    }

    if (leaveCount <= 0) {
      showAlertMessage("Leave count must be at least 1.", "warning");
      return;
    }

    try {
      const user = users.find((user) => user.username === selectedUser);
      if (!user) {
        showAlertMessage("User not found.", "danger");
        return;
      }

      const newLeaveData = {
        userId: user._id,
        username: user.username,
        name: user.name,
        department: "Sample Department",
        leaveCount: leaveCount,
      };

      const response = await axios.post(
        "https://backend.ems.uk.hiradentallab.com/api/leavesmanual/createLeaveEntry",
        newLeaveData
      );

      if (response.status === 201) {
        showAlertMessage("Leaves added successfully!", "success");
        setLeaveCount(0);
        setSelectedUser("");
      }
    } catch (error) {
      console.error("Error adding leave:", error);
      showAlertMessage("Failed to add leave. Please try again later.", "danger");
    }
  };

  const incrementLeave = () => setLeaveCount((prev) => prev + 1);
  const decrementLeave = () => setLeaveCount((prev) => Math.max(0, prev - 1));

  const handleLeaveCountChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^[0-9\b]+$/.test(value)) {
      setLeaveCount(value ? parseInt(value, 10) : 0);
    }
  };

  return (
    <div className="container-fluid">
      <div>
        <h1 className="add-attendance-title">
          <BsPersonPlusFill /> Add Leave
        </h1>
        <hr />
      </div>

      <div className="add-attendance-container">
        {showAlert && (
          <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
            {alertMessage}
          </Alert>
        )}

        <Row className="align-items-end mb-3">
          <Form.Group as={Col} xs={12} md={4} controlId="formGridUsername">
            <Form.Label>
              User <span className="required">*</span>:
            </Form.Label>
            <CustomSelect
              options={users}
              value={selectedUser}
              onChange={setSelectedUser}
              placeholder="--Select User--"
            />
          </Form.Group>

          <Form.Group as={Col} xs={12} md="auto">
            <Form.Label>Leave Count:</Form.Label>
            <div className="d-flex align-items-center">
              <Button variant="secondary" onClick={decrementLeave}>-</Button>
              <Form.Control
                type="text"
                value={leaveCount}
                onChange={handleLeaveCountChange}
                className="mx-2 text-center"
                style={{ width: "60px" }}
              />
              <Button variant="secondary" onClick={incrementLeave}>+</Button>
            </div>
          </Form.Group>
        </Row>

        <Button
          type="button"
          className="btn btn-primary"
          onClick={handleAddLeave}
        >
          <IoMdAdd /> Add Leave
        </Button>
      </div>
    </div>
  );
}
